import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

import DefaultLayout from "/home/runner/work/documentation/documentation/node_modules/gatsby-theme-doctornpm/src/components/layout.js";
export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <p>{`Outlined in this document are the practices and policies that npm
applies to help ensure that we release stable/secure software, and
react appropriately to security threats when they arise.`}</p>
    <h2>{`Table of Contents`}</h2>
    <ol>
      <li parentName="ol"><a parentName="li" {...{
          "href": "#reporting-security-problems-to-npm"
        }}>{`Reporting Security Problems to npm`}</a></li>
      <li parentName="ol"><a parentName="li" {...{
          "href": "#security-point-of-contact"
        }}>{`Security Point of Contact`}</a></li>
      <li parentName="ol"><a parentName="li" {...{
          "href": "#critical-updates-and-security-notices"
        }}>{`Critical Updates And Security Notices`}</a></li>
    </ol>
    <h2>{`Reporting Security Problems to npm`}</h2>
    <p>{`If you need to report a security vulnerability.  Please visit `}<a parentName="p" {...{
        "href": "https://npmjs.com/support"
      }}>{`https://npmjs.com/support`}</a>{`.
If your issue is specific to your account, such as lost credentials or problems with two-factor authentication, contacting `}<a parentName="p" {...{
        "href": "https://npmjs.com/support"
      }}>{`our support team`}</a>{` is more appropriate.`}</p>
    <p>{`We review all security reports on the next business day.  Note that
the npm staff is generally offline for most US holidays, but please do
not delay your report!  Our off-hours support staff can fix many
issues, and will alert our security point of contact if needed.`}</p>
    <h2>{`Security Point of Contact`}</h2>
    <p>{`Any security tickets opened using `}<a parentName="p" {...{
        "href": "https://npmjs.com/support"
      }}>{`https://npmjs.com/support`}</a>{`
will be escalated to the security point of contact, who will delegate incident response
activities as appropriate. This is the best and fastest way to contact npm about any security-related matter.`}</p>
    <h2>{`Critical Updates And Security Notices`}</h2>
    <p>{`We learn about critical software updates and security threats from a
variety of sources:`}</p>
    <ul>
      <li parentName="ul">{`Ubuntu's security notices page: `}<a parentName="li" {...{
          "href": "https://usn.ubuntu.com/"
        }}>{`https://usn.ubuntu.com/`}</a></li>
      <li parentName="ul">{`The Node.js mailing list.`}</li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "https://npmjs.com/support"
        }}>{`Security tickets`}</a>{` sent to us.`}</li>
      <li parentName="ul">{`and other media sources.`}</li>
    </ul>
    <h2>{`Changes`}</h2>
    <p>{`This is a living document and may be updated from time to time.
Please refer to the `}<a parentName="p" {...{
        "href": "https://github.com/npm/documentation/blob/main/content/policies/security.mdx"
      }}>{`git history for this
document`}</a>{`
to view the changes.`}</p>
    <h2>{`License`}</h2>
    <p>{`This document may be reused under a `}<a parentName="p" {...{
        "href": "https://creativecommons.org/licenses/by-sa/4.0/"
      }}>{`Creative Commons
Attribution-ShareAlike
License`}</a>{`.`}</p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      